
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.182 16.9c0 3.7-2.7 3.9-5.5 3.9-2.1 0-4.5.3-6.6-.1-3.4-.8-2.5-4.7-2.5-7.3 0-.9-.2-2.1 0-3 .5-2.3 2.3-2.6 4.2-2.6 1 0 1-3.1 0-3.1-4.3 0-5.6 2.9-5.6 6.8 0 3.1-.9 8.1 1.3 10.8 2.1 2.7 7.4 1.7 10.4 1.7 4.5-.1 5.7-3 5.7-7.1 0-1.9-1.4-1.9-1.4 0z"}}),_c('path',{attrs:{"d":"M22.682 4c-2.6.1-5.3.2-7.9.4-1 0-1 3.2 0 3.2 1.5-.1 3-.1 4.4-.2-1.9 1.8-3.7 3.7-5.6 5.6-.6.6-.2 3.7.7 2.7l7.5-7.5c-.1 1.5-.2 3.1-.4 4.6 0 .4-.1 1.8.5 1.9.6.2.8-.7.9-1.1.2-2.5.4-5.1.6-7.6 0-.4 0-2-.7-2z"}})])
          )
        }
      }
    